<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-6 col-sm-6 col-md-6">
                <form @submit.prevent="'return false'" >
                    <div class="form-group" v-if="errors.length" >
                        <ul class="list-group">
                        <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
                        </ul>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Nazwa produktu</label>
                        <search-input
                            v-model="form.productName"
                            v-bind:items="productsNames"
                        />
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Dzień przyjęcia reklamacji</label>
                        <datepicker
                            class="mt-1"
                            v-model="form.createdAt"
                            :monday-first="true"
                            :language="lang"
                        ></datepicker>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Telefon kontaktowy</label>
                        <input class="form-control" v-model="form.contactPhone"/>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Opis reklamacji</label>
                        <textarea class="form-control" v-model="form.description"></textarea>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Historia kontaktu</label>
                        <div v-for="item in form.historyItems" :key="item.id" class="history-item-bag">
                            <datepicker
                                class="left"
                                v-model="item.createdAt"
                                :monday-first="true"
                                :language="lang"
                            ></datepicker>
                            <span class="center"></span>
                            <textarea rows="1" class="form-control right" v-model="item.description"></textarea>
                            <button v-if="item.id" class="btn btn-dark btn-sm mt-1 ml-2" @click.prevent="deleteHistoryItemClick(item.id)">X</button>
                        </div>
                        <div>
                            <button class="btn btn-circle torre-red" @click.prevent="addHistoryItemClicked">
                                <i class="material-icons" >
                                add
                                </i>
                            </button>
                        </div>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Status reklamacji</label>
                        <select class="form-control select-size" v-model="form.status">
                            <option v-for="option in statusesOptions" :key="option.id" v-bind:value="option.id" >
                            {{ option.text }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Utworzona przez</label>
                        <input class="form-control" type="text" :placeholder="form.createdBy" readonly>
                    </div>

                    <div class="row ">
                        <div class="col-xs-2 col-md-6 col-sm-6">
                            <input class="btn btn-success btn-sm mr-2 torre-btn" type="button" value="Zapisz" @click="submit">
                            <router-link class="btn btn-secondary btn-sm mr-2" :to="{ name: 'complaints' }">Anuluj</router-link>
                        </div>
                        <div class="col-xs-2 col-md-6 col-sm-6 text-right">
                            <button @click.prevent="deleteComplainConfirm" class="btn btn-dark btn-sm">Usuń</button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>
<script>
import datepicker from 'vuejs-datepicker';
import {pl} from 'vuejs-datepicker/dist/locale'
import restClient from '@/components/complaints/ComplaintsRestClient'
import validator from '@/components/complaints/Validator'
import service from '@/components/complaints/ComplaintsService'

export default {
    name: 'ComplaintsEdit',
    components: {
        datepicker
    },
    data: () => {
        return {
            errors: [],
            productsNames: [],
            lang: pl,
            statusesOptions: service.availableStatuses(),
            form: {
                id: "",
                productName: "",
                description: "",
                contactPhone: "",
                createdAt: "",
                createdBy: "",
                status: "",
                historyItems: []
            }
        }
    },
    created() {
        this.init()
    },
    methods: {
        deleteHistoryItemClick(id) {
            service.showPrompt("Chcesz usunąć wpis?", () => this.deleteHistoryItem(id))
        },
        deleteHistoryItem(id) {
            restClient
                .deleteHistoryItem(id)
                .then(res => {
                    service.notifyUserWithMessage("Usunięto wpis")
                    this.removeHistoryItem(id)
                })
                .catch(err => {
                    this.handleError(err)
                })
        },
        removeHistoryItem(id) {
            this.form.historyItems = service.removeHistoryItem(this.form.historyItems, id)
        },
        addHistoryItemClicked() {
            this.form.historyItems.push(
                service.createHistoryItem()
            )
        },
        init() {
            restClient
                .fetchComplain(this.$route.params.id)
                .then(res => {
                    this.form = res.data
                })
                .catch(err => {
                    this.handleError(err)
                })
            this.loadProductNames()
        },
        scrolTop() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        },
        submit() {
            this.errors = []
            this.errors = validator.validate(this.form, this.productsNames)
            if (this.errors.length > 0) {
                this.scrolTop()
                return false
            }
            restClient
                .editComplain(service.prepareFormData(this.form))
                .then(res => {
                    service.notifyUser("Zapisano", this.form.productName)
                    this.goToComplaints()
                })
                .catch(err => {
                    this.handleError(err)
                })
        },
        handleError(err) {
            console.log(err)
            this.goToComplaints()
        },
        deleteComplain() {
            restClient
                .deleteComplain(this.form.id)
                .then(res => {
                    service.notifyUser("Usunięto", this.form.productName)
                    this.goToComplaints()
                })
                .catch(err => {
                    this.handleError(err)
                })
        },
        goToComplaints() {
            this.$router.push({name: 'complaints'})
        },
        deleteComplainConfirm() {
            service.showPrompt("Chcesz usunąć reklamację?", this.deleteComplain)
        },
        loadProductNames() {
            restClient.loadProductNames()
                .then(res => {
                    this.productsNames = res.data
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
}
</script>
<style lang="scss" >

    .vdp-datepicker {
        input {
            border: 1px solid #ced4da;
            padding: 0.25rem 0.5rem;
            font-size: 0.875rem;
            line-height: 1.5;
            border-radius: 0.25rem;
            color: #495057;
        }
    }

    .history-item-bag {
        display: flex;
        align-items: flex-start;
        padding: 10px 0;

        .center {
            flex: 0.5;
        }

        .left {
            flex: 1;
        }

        .right {
            flex: 4;
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/complaints/ComplaintsEdit.vue